export const Hero1 = [
    {
        id: 1 ,
        line1: 'تعـــلم  تخصــص',
        line2: 'بمسـتوى جامعــــي',
        line3: 'متــاح للجميـــع بالمجـــــان',
    }
];

export const Welcome1 = [
    {
        id: 1 ,
        title: 'أهلا  بك في أكاديمية اللعبة',
        line: 'أكاديميتنـا لن تحل مشاكلك ولكن ستعلمك كيف تفعلهـا بنفسـك',
        quote: 'لا تعطني سمكة، علمني كيف أصطاد',
    }
];

export const AboutUs1 = [
    {
        id: 1 ,
        firstP: `نحن مؤسسـة غير ربحيـة أسسها الشاب الأردني ثائر أبو غـوش 
            في أواخر عام ٢٠١٩`,
        lastP: `
        تركيزنا موجـه تحديدا نحو الشباب في الشـرق الأوسط وشمال أفريقيـا،
        ونهدف إلى توجيـه الشباب نحو تحقيق نظام شخصـي فعـال واحتراف
        مهني وحريـة اقتصاديـة.
        `,
    }
];

export const Firstquote1 = `
        معـًا لنبني جيــل يعمــل بإقبـال على الحيـاة، متمسـك بمبادئـه 
        و يملك أسـاس لمستقبـل أفضـل لعالمنـا العربي و الإسلامـي.
    `;


export const Services1 = [
    {
        id: 1 ,
        firstP: `
        أكاديميتنــا تقـدم لك أكثـر مـن 14 تخصـصا في مهــارات متنوعــة, تبـدأ مــن 
        التصميـم والبرمجـة البسيطـة حتى بنـاء الميتـافيـرس القادمـة 
        وتعـلم الذكاء الاصطناعي والتعمق في الأمـن السيبراني 
        `,
        lastP: `
        كل هذه تخصصات نقدمها في قالب تعليمي تفاعلي طورناه بأنفسنا ليتناسب
        مع التعلم الذاتـي عن بعد الذي يملك نسب انسحاب عاليـة، لهذا معنـا ستجد 
        نظاماً  يساعدك على الاستمرار ويحمل جدية الجامعات  بنظام اختبارات 
        نظريـة وعمليـة صـارم.
        `,
    }
];

export const Features1 = [
    {
        id: 1 ,
        title: 'التأسيس البرمجي',
        text: `
        في هذه الدورة ندعوك لدخول عالم البرمجة و تعلم قواعدها وليس لغاتها فحسب،
        فهو اللبنة الأساسية حتى تبدع في أي تخصص تختاره لاحقا
        لهذا لا تفوت حجز مكانك بالمجان
        `,
    }
];

export const soon1 = 'قريبا...';



export const Secondquote1 =  `
            نحو عالم يتفوق فيه شبابنا بمهاراتهم ولا يكون أبعد طموحهم وظيفة لا تعيلهم إذا مرضوا
`;

export const teamP1 = "فريقنـا قائـم بالكامـل على التطـوع وأعضاءه من مختلف أقطـار عالمنـا العربـي متخصصين بمختلف المجالات أو مساعدين لمختصين بدأ الفريق في 2019 بفردين وامتد للعشرات حتى تجاوز في 2022 بفضـل اللـه 200 عضو ثابت. ومن نقـاط قوة فريقنـا أن الأعضاء ملتزمون بالكامـل بتحقيق رؤيـة الأكاديميـةوبالطبـع عددنـا الكبير يعكس حجم رؤيتنا وأهدفنـا و بالتأكيد شكـل هذا تحـدي بكيفية تنظيم هذا القدر من الأعمال في مختلف هذه المواضيع الحساسـة التي نتخصص بها كالبرمجة وغيرها،لكن التأقلم كان خيارنا الوحيد لتحقيـق الهدف مما خلق فريـق أقـوى متكيـف مع المعطيات وذو خبـرة، ويجدر بالذكر أننا غير مدعومـين من أي جهـة أو أفـراد مما يعني نقص كبير بالموارد و الاقتصار على الأمور الضرورية من اشتراكات وغيرها من المصروفات التي يؤمنها مؤسس المشروع ثائر ولهذا أصبح فريقنا كالقطار يسير بثبات ولا يحيد عن سكته مهما صعبت الظروف وهم الكنز والبطـل الحقيقي خلف هذا العمـل.";

export const thirdQ1 = "نقـدم هذا العمـل لكـل أخ وأخت أغلقت في وجههم الأبواب ولم يفقدوا الأمل أنتم الإلهــام لنـا والدافع للاستمرار ";
